import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "@/app/utils/handleApiError";
import { RejectValueType } from "../redux/redux.types";
import { fetchAgreements } from "./agreements.service";
import { AgreementsResponse } from "./agreements.types";

export const getAgreements = createAsyncThunk<
  AgreementsResponse,
  void,
  RejectValueType
>("agreements/getAgreements", async (_, { rejectWithValue }) => {
  try {
    return await fetchAgreements();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
